import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c713d890"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "h-screen w-screen flex-col overflow-auto flex",
  style: {"background":"#1E2026"}
}
const _hoisted_2 = { class: "header px-0" }
const _hoisted_3 = { class: "content text-white flex flex-1 p-4" }

import MqttAPI, { IGetMachineProductionGetMqttConnectInfoVo, } from "@/api/machine"
import layoutHeader from "@/components/layout/header/header.vue";
import { getMqtt, getMqttConnectInfor } from "@/constant";
import { Mqtt } from '@/utils/mqtt';
import { onMounted, onUnmounted, ref, watch } from "vue";
import machine from "./machine/index.vue";
import peopleTeam from "./peopleTeam/index.vue";
import reportRecord from "./reportRecord/index.vue";
import workOrder from "./workOrder/index.vue";
import CryptoJS from "crypto-js";
import { connectStatu } from '@/utils/mqtt'

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

onMounted(() => {
  connectMqtt()
})

onUnmounted(() => {
  console.debug("离线注销MQTT！")
  if (mq.value) {
    //已经存在mqtt信息进行原来的mqtt注销
    mq.value.end();
    mq.value = null;
  }
})
watch(() => connectStatu.value, newVal => {
  if (!newVal) {
    getMqttConnectInfor()
    setTimeout(connectMqtt, 1000)
  }
}, {
  deep: true,
})
/**
 * 订单id
 */
const orderId = ref();

/**
 * mq对象
 */
let mq = ref();

/**
 * 获取实时数据
 */
let realTimeData = ref({})
let pageNum = ref(localStorage.getItem("pageName") ? localStorage.getItem("pageName") : "peopleTeam");
const switchPage = (page: string, parm: any) => {
  localStorage.setItem("pageName", page)
  //切换页面
  pageNum.value = page;
  switch (page) {
    case "workOrder":
      break;
    case "machine":
      orderId.value = parm;
      break;
    case "reportRecord":
      break;
    case "peopleTeam":
      break;

    default:
      break;
  }
};
// 数据处理
const dealMessage = (topic: string, payload: Buffer) => {
  let mqData = JSON.parse(payload.toString()).items;
  realTimeData.value = { "outCount": mqData.outCount, 'speed': mqData.speed }
};
// 连接MQTT服务器
const connectMqtt = () => {
  try {
    if (mq.value) {
      //已经存在mqtt信息进行原来的mqtt注销
      mq.value.end();
      mq.value = null;
      console.debug("重连注销MQTT！")
    }
    let mqttConfig: IGetMachineProductionGetMqttConnectInfoVo = getMqtt();
    let url = "wss://" + mqttConfig.host + ":" + mqttConfig.port + "/mqtt";
    mq.value = new Mqtt(url)
    let clientid = mqttConfig.token + "|" + "signmethod=hmacmd5" + ",timestamp=" + mqttConfig.timestamp;
    mq.value.connect({
      username: mqttConfig.username,
      password: CryptoJS.HmacMD5(clientid, mqttConfig.secretKey).toString(),
      properties: {
        sessionExpiryInterval: 7200,//会话间隔
      },
      clientId: clientid,
      clean: false,//离线时是否接收 QoS 1 和 2 的消息 false 为接收,true为不接收
      reconnectPeriod: 5000, //重连时间间隔
      connectTimeout: 5000,
      //保活时间60秒
      keepalive: 60,
    })
    // 订阅主题 /topicName/#  #通配符  匹配以/gb212/开头的主题
    mq.value.subscribe(mqttConfig.topic, 2)
    // 设置主题 /topicName/data 的消息回调
    mq.value.message_callback(mqttConfig.topic, dealMessage)
    // 设置主题 /topicName/rx 的消息回调
    // mq.message_callback('/topicName/topic2', dealPackage)
    // 将Mqtt变量mq放到Mqtt客户端列表中
    // state.mqttList.push(mq)
  } catch (error) {
    console.log(error)
  }
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(layoutHeader, {
        onSwitchPage: switchPage,
        option: _unref(pageNum)
      }, null, 8, ["option"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_unref(pageNum) === 'workOrder')
        ? (_openBlock(), _createBlock(workOrder, {
            key: 0,
            onSwitch: switchPage
          }))
        : _createCommentVNode("", true),
      (_unref(pageNum) === 'machine')
        ? (_openBlock(), _createBlock(machine, {
            key: 1,
            onSwitch: switchPage,
            "work-id": orderId.value,
            realTimeData: _unref(realTimeData)
          }, null, 8, ["work-id", "realTimeData"]))
        : _createCommentVNode("", true),
      (_unref(pageNum) === 'reportRecord')
        ? (_openBlock(), _createBlock(reportRecord, { key: 2 }))
        : _createCommentVNode("", true),
      (_unref(pageNum) === 'peopleTeam')
        ? (_openBlock(), _createBlock(peopleTeam, { key: 3 }))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})